<template>
	<div>
		<div v-if="loader" class="flex center text-center mb-1">
			<i class="fas fa-cog fa-spin fa-2x"></i>
			Loading....
		</div>

		<form v-if="!loader" :action="endPoint" class="list-filter flex box" method="get" ref="filterForm">
			<div class="two form-group">
				<label for="limit"><i class="fas fa-fw fa-list-ul"></i> Show</label>
				<select id="limit" name="limit" @change="onFormChange" v-model="selectedLimit">
					<option value="null">25</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>
			</div>

			<div class="two form-group">
				<label for="status"><i class="fas fa-fw fa-archive"></i>Status</label>
				<select id="status" @change="onFormChange" name="status" v-model="selectedStatus">
					<option value="null">All</option>
					<option v-for="state in states" :value="state.name">{{ state.name }}</option>
				</select>
			</div>

			<div class="eight form-group">
				<label for="filter"><i class="fas fa-fw fa-filter"></i> Filter</label>
				<div class="input-group">
					<input @change="checkReset" @keyup="onFilterChange" class="input-small" id="filter" name="filter" placeholder="Filter in Author, Email or Comment" type="text" v-model="urlParams.filter">
					<button :disabled="!this.filterEnabled" @click="clearForm" class="btn btn-primary">Filter</button>
				</div>
			</div>
		</form>

		<div class="table-responsive">
			<table class="comments">
				<thead>
					<tr>
						<th>Provider</th>
						<th>Date</th>
						<th>Author</th>
						<th>Comment</th>
						<th>Ratings</th>
						<th class="actions">Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="userReviewComment in userReviewCommentList">
						<td class="date"><strong>{{userReviewComment.provider}}</strong></td>
						<td class="date">{{userReviewComment.created_at}}</td>
						<td class="author">
							<ul>
								<li>{{userReviewComment.user_name}}</li>
								<li>{{userReviewComment.user_email}}</li>
								<li>{{userReviewComment.user_ip}}</li>
							</ul>
						</td>
						<td class="comment">
							<div style="width: 450px">{{userReviewComment.comment}}</div>
						</td>
						<td class="nowrap">
							<div>Overall: {{userReviewComment.rating_overall}}</div>
						</td>
						<td class="nowrap">
							<a class="btn btn-icon btn-success" title="Accept and Publish" v-show="userReviewComment.status !== 'approved'" @click.prevent="approveReview(userReviewComment.id)"><i class="fas fa-fw fa-check"></i></a>
							<a class="btn btn-icon btn-danger" title="Delete Comment" @click.prevent="deleteUserReview(userReviewComment.id)"><i class="fas fa-fw fa-trash"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			dataUserReviewCommentList: {
				type: Object
			},
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			}
		},

		data() {
			return {
				userReviewCommentList: this.dataUserReviewCommentList,
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || {},
				loader: false,
				filterEnabled: this.dataUrlParams.filter && this.dataUrlParams.filter.length > 0,
				selectedLimit: this.dataUrlParams.limit ? this.dataUrlParams.limit : null,
				states: [
					{name: 'approved'},
					{name: 'pending'},
				],
				selectedStatus: this.dataUrlParams.status ? this.dataUrlParams.status : null,
			}
		},

		methods: {
			clearForm: function () {
				$('input, select').each(function (_, inp) {
					if ($(inp).val() === '' || $(inp).val() === 'null' || $(inp).val() === null)
						inp.disabled = true;
				});
			},
			checkReset: function () {
				if (this.urlParams.filter.length === 0) {
					this.onFormChange();
				}
			},
			onFormChange: function () {
				this.loader = true;
				this.clearForm();
				this.$refs.filterForm.submit();
			},
			onFilterChange: function () {
				this.filterEnabled = this.urlParams.filter && this.urlParams.filter.length > 0;
			},
			approveReview: function (id) {
				let userReviewComment = this.userReviewCommentList[id];
				axios.post('/api/' + this.$selectedSite.slug + '/user-review-comments/approve/' + id, userReviewComment)
						.then(response => {
							if (response.data.success) {
								this.$toastr.success('Comment approved successfully', 'Success');
								location.reload();
							} else {
								this.$toastr.error(response.data.failed, 'Error');
							} // if
						})
						.catch(e => {
							this.errors.record(e.response.data);
							this.$toastr.error('Comment approve failed.', 'Error');
						});
			},
			deleteUserReview: function (id) {
				let vm = this;
				vm.$dialog.confirm('Are you sure you want to delete this Comment?')
						.then((dialog) => {
							axios.delete('/api/' + this.$selectedSite.slug + '/user-review-comments/' + id)
									.then(response => {
										vm.$toastr.success('Delete successful.');
										location.reload();
									})
									.catch(errors => {
										vm.$toastr.error('Delete failed.');
									});
						})
						.catch(error => {
							vm.$toastr.error('Delete aborted.');
						});
			}
		}
	}
</script>

<style scoped>

</style>
